import { extractOfferFields } from './srOnly';

// Builds schema.org/Offer JSON-LD for a single promo. Only intended for
// isCustomAsset promos - fields are sourced from extractOfferFields so this
// can never diverge from the sr-only text rendered for the same promo.
export const buildOfferSchema = (promo) => {
	const fields = extractOfferFields(promo);
	if (!fields) return null;

	const {
		name,
		description,
		validFrom,
		validThrough,
		price,
		model,
		modelYear
	} = fields;

	const itemOffered = model
		? {
				'@type': 'Vehicle',
				model,
				...(modelYear && { vehicleModelDate: modelYear })
		  }
		: null;

	if (
		!name &&
		!description &&
		!validFrom &&
		!validThrough &&
		!price &&
		!itemOffered
	) {
		return null;
	}

	return {
		'@context': 'https://schema.org',
		'@type': 'Offer',
		...(name && { name }),
		...(description && { description }),
		...(validFrom && { validFrom }),
		...(validThrough && { validThrough }),
		...(price && { price, priceCurrency: 'USD' }),
		...(itemOffered && { itemOffered })
	};
};
